import { useEffect, useState } from "react";
import ExportToCsv from '../../../shared/components/ExportToCSV/ExportToCsv';
import EntityHistoryGrid from "../../../shared/components/entity-history/EntityHistoryGrid";
import EntityHistoryModel from "../../../customer/model/EntityHistoryModel";
import { CustomerHistoryLabel as cstHistoryLabel } from '../../../shared/util/label'
import EmployeeSetupService from "../service/EmployeeSetupService";
import './EmployeeHistory.scss';
import * as constant from '../../../shared/util/constant'
import { CommonUtility } from "../../../Services/CommonUtility";
import Button from "react-bootstrap/esm/Button";
import * as label from '../../../shared/util/label'

export interface IEmployeeHistory {
        historyGridData: any[];
        fileName?: string;
        setOpen: (key: string) => void;
        loadDataFlag: (key: boolean) => void;
};

const EntityHistoryView: React.FunctionComponent<IEmployeeHistory> = (props) => {
    const historyGridData = props.historyGridData || [];
    const fileName = props.fileName || "history.csv"; 
    
    const CancelEdit = () => {
        props.setOpen("0"); // Close accordion panel
        props.loadDataFlag(true);
  };

    return (
        <>
            {historyGridData.length > 0 ? (
                <div>
                    <EntityHistoryGrid
                        data={historyGridData}
                        columns={[
                            {
                                Header: cstHistoryLabel.USER,
                                accessor: 'changedBy',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 250
                            },
                            {
                                Header: cstHistoryLabel.TIMESTAMP,
                                accessor: 'changedDate',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 250
                            },
                            {
                                Header: cstHistoryLabel.FIELD,
                                accessor: 'fieldName',
                                Cell: row => {
                                    let displayValue = row.value;
                                    if (typeof displayValue === 'string' && displayValue.startsWith('_')) {
                                        displayValue = CommonUtility.capitalizeFirstCharOfEachWord(displayValue.substring(1));
                                    }
                                    return <div><span title={displayValue}>{displayValue}</span></div>;
                                },
                                width: 275
                            },
                            {
                                Header: cstHistoryLabel.OLD_VALUE,
                                accessor: 'oldValue',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 300
                            },
                            {
                                Header: cstHistoryLabel.NEW_VALUE,
                                accessor: 'newValue',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 300
                            },
                            {
                                Header: cstHistoryLabel.ACTION,
                                accessor: 'action',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 190
                            },
                            {
                                Header: cstHistoryLabel.ENTITY,
                                accessor: 'entity',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 200
                            }
                        ]}
                        hiddenColumns={['selection']}
                        groupByColumns={[]}
                        columnsGroupOn={[]}
                        showFilters={true}
                        sortDefault={[]}
                        defaultPageSize={10}
                        paginationDisabled={false}
                        entityHistoryMainDivClassName="employee-history-grd-div"
                        entityHistoryGrdTableContainerClass="employee-history-table-container"
                        modalClassName=""
                    />                                  
                    <div style={{ textAlign: 'right', marginBottom: '1rem', marginRight: '1rem' }}>
                        <ExportToCsv
                            data={historyGridData}
                            headers={[
                                cstHistoryLabel.USER,
                                cstHistoryLabel.TIMESTAMP,
                                cstHistoryLabel.FIELD,
                                cstHistoryLabel.OLD_VALUE,
                                cstHistoryLabel.NEW_VALUE,
                                cstHistoryLabel.ACTION,
                                cstHistoryLabel.ENTITY
                            ]}
                            fileName={fileName}
                            getRow={row => [
                                row.changedBy,
                                new Date(row.changedDate).toLocaleString('en-US'),  
                                (typeof row.fieldName === 'string' && row.fieldName.startsWith('_')) ? CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName.substring(1)) : CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName),
                                row.oldValue,
                                row.newValue,
                                row.action,
                                row.entity
                            ]}
                        />
                    </div>
                </div>
            ) : (
                <div style={{ height: "200px" }}>No record found</div>
            )}

            <div className={historyGridData.length <= 0 ? 'employee-history-close-btn-container-no-data' : 'employee-history-close-btn-container-with-data'}>
                <Button
                                    variant="outline-primary"
                                    onClick={() => CancelEdit()}
                                    tabIndex={20}
                                    id="btnCancel"
                                    disabled={false}
                                    style={{ minWidth: "90px" }}
                                    className="me-2"
                                >
                                    {label.CLOSE.toLocaleUpperCase()}
                </Button>
            </div>
        </>
    );
};
export default EntityHistoryView;
